// Client mirror of functions-common/src/charts/datasets/index.ts. Keep in sync.

import type { DatasetDefinition, DatasetKey } from '../types.js'
import { workDataset } from './work.js'
import { budgetDataset } from './budget.js'
import { stockDataset } from './stock.js'
import { quotaDataset } from './quota.js'
import { formsDataset } from './forms.js'
import { reliabilityDataset } from './reliability.js'
import { dailyDataset } from './daily.js'
import { timeDataset } from './time.js'
import { focusDataset } from './focus.js'

export * from './work.js'
export * from './budget.js'
export * from './stock.js'
export * from './quota.js'
export * from './forms.js'
export * from './reliability.js'
export * from './daily.js'
export * from './time.js'
export * from './focus.js'

export const DATASET_CATALOG: Record<DatasetKey, DatasetDefinition> = {
  work: workDataset,
  budget: budgetDataset,
  stock: stockDataset,
  quota: quotaDataset,
  forms: formsDataset,
  reliability: reliabilityDataset,
  daily: dailyDataset,
  time: timeDataset,
  focus: focusDataset,
}

export function getDatasetDefinition(key: DatasetKey): DatasetDefinition | undefined {
  return DATASET_CATALOG[key]
}
